import { useState } from 'react'

export type Severity = 'success' | 'info' | 'warning' | 'error'

export type MessageState = {
  message: string | null
  severity: Severity
  isVisible: boolean
  setMessage: (message: string | null) => void
  setSeverity: (severity: Severity) => void
  hide: () => void
  showError: (message: string) => void
  showSuccess: (message: string) => void
  showInfo: (message: string) => void
}

export const useMessageState = (): MessageState => {
  const [message, setMessage] = useState<string | null>(null)
  const [severity, setSeverity] = useState<Severity>('info')
  const [isVisible, setVisible] = useState<boolean>(false)

  const show = () => setVisible(true)

  const hide = () => {
    setVisible(false)
    setMessage(null)
  }

  const showError = (message: string) => {
    setSeverity('error')
    setMessage(message)
    show()
  }

  const showSuccess = (message: string) => {
    setSeverity('success')
    setMessage(message)
    show()
  }

  const showInfo = (message: string) => {
    setSeverity('info')
    setMessage(message)
    show()
  }

  return {
    message,
    severity,
    isVisible,
    setMessage,
    setSeverity,
    hide,
    showError,
    showSuccess,
    showInfo,
  }
}
